export function compareStrategyIncompatibleError(expected: string[], passed: string): Error {
  return Error(`Compare strategy is incompatible. Pass ${expected.join(' or ')} instead of ${passed}`);
}

export function propsNotExistsInComparedObjectsError(props: string = ''): Error {
  return Error(
    `Props ${props} not exists in compare objects. You should pass own compare function and specific own props to compare`
  );
}
